import React from "react";
import { useMutation } from "@apollo/client";
import { useForm } from "react-hook-form";
import { ADD_COST } from "../gql/mutations";

const AddCostForm = ({ id, unpaidMenus, setUnpaidMenus }) => {
    const { register, handleSubmit } = useForm();

    const [addCost] = useMutation(ADD_COST);

    const onCostSubmit = async (costData, event) => {
        const amount = Math.ceil(parseFloat(costData.amount));
        try {
            await addCost({
                variables: {
                    menuId: event.target.id,
                    amount: amount
                },
            });
            const updatedMenus = [...unpaidMenus, costData];
            setUnpaidMenus(updatedMenus);
        } catch (err) {
            console.error(err);
        }
    };

    return (
        <>
            <form className="addCostForm" onSubmit={handleSubmit(onCostSubmit)} id={id} >
                <input {...register("amount", { required: true })} placeholder="Amount"></input>
                <input type="submit" value="Add Cost"></input>
            </form>
        </>
    )
};

export default AddCostForm;